import { useCallback } from "react";
import { useStoryBibleStore } from "../../../stores/storyBibleStore";
import { useProjectStore } from "../../../stores/projectStore";

const typeTitleMap = {
  seed: "Braindump",
  genre: "Genre",
  style: "Style",
  synopsis: "Synopsis",
  outline: "Outline",
};

export const useStoryBibleHistory = (type, setter) => {
  const setHistory = useStoryBibleStore((state) => state.setHistory);
  const storyEngineIdRef = useStoryBibleStore((state) => state.storyEngineIdRef);
  const project = useProjectStore((state) => state.project);

  const openHistory = useCallback(() => {
    const store = useStoryBibleStore.getState();
    const owner = store.owner;
    setHistory({
      storyEngineId: storyEngineIdRef.current,
      key: type,
      title: typeTitleMap[type],
      onRestore: (contents) => {
        if (store.isCurrentOwner(owner)) setter(contents);
      },
      projectName: project.title,
    });
  }, [type, project.title, setHistory, storyEngineIdRef, setter]);

  return openHistory;
};
